<template>
  <div class="flex items-center gap-1.5 p-1.5">
    <VideoLengthIcon class="text-icon-normal flex-shrink-0" />
    <BaseText type="label" size="sm" class="text-text-muted">
      Video Length Filter
    </BaseText>
  </div>
</template>

<script>
import VideoLengthIcon from '../../globals/Icons/FilterIcons/VideoLengthIcon.vue'

export default {
  name: 'VideoLengthSearchReplacer',
  components: {
    VideoLengthIcon
  }
}
</script>